import { OUTREACH_ANALYTICS_TIMEZONE } from '@apps/web/components/admin/outreach_observability/constants';

// Matches the backend's fixed dashboard timezone (_ANALYTICS_TIMEZONE).
export const ANALYTICS_TIMEZONE = OUTREACH_ANALYTICS_TIMEZONE;

// Below this width the feed's inline detail panel is hidden; note
// selection routes to the standalone note page instead.
export const INLINE_PANEL_MIN_WIDTH_PX = 1024;

/** Whether the feed's inline detail panel is visible at this viewport. */
export function isInlinePanelVisible(): boolean {
    if (typeof window.matchMedia !== 'function') {
        return true;
    }
    return window.matchMedia(`(min-width: ${INLINE_PANEL_MIN_WIDTH_PX}px)`)
        .matches;
}
